import React, { Component } from "react"
import PropTypes from "prop-types"
import { FaPhone, FaEnvelope, FaTimes } from "./icons"

// TODO: rename to contactQualification
export default class ContactQualification extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // if this is an empty string instead of a null
      // the CQ field will appear in the leadbox even if
      // the user hasn't answered the question
      contactQualification: null,
    }
  }

  _handleContactQualificationAnswer(answer) {
    this.setState({ contactQualification: answer })
  }

  render() {
    const styles = {
      submitButton: {
        marginTop: "20px",
      },
    }

    const {
      props: {
        title,
        subtitle,
        answerYesPhone,
        answerYesEmail,
        answerYes,
        answerNo,
        formUrl,
        configKey,
        creationToken,
        configParam,
      },
      state: { contactQualification },
    } = this

    return (
      <div className="contact-qualification-container">
        <form action={formUrl} method="post" data-remote className="center">
          <p className="form-title"> {title} </p>
          <div className="buttons-container">
            <button
              className="button-qualification-answer"
              onClick={() => this._handleContactQualificationAnswer("email")}
            >
              <p className="title"> {answerYes} </p>
              <FaEnvelope
                width="30"
                height="30"
                color="white"
                innerClassName="icon"
              />
              <p className="subtitle"> {answerYesEmail} </p>
            </button>
            <button
              className="button-qualification-answer"
              onClick={() => this._handleContactQualificationAnswer("phone")}
            >
              <p className="title"> {answerYes} </p>
              <FaPhone
                width="30"
                height="30"
                color="white"
                innerClassName="icon"
              />
              <p className="subtitle"> {answerYesPhone} </p>
            </button>
            <button
              className="button-qualification-answer grayed-out"
              onClick={() => this._handleContactQualificationAnswer("no")}
            >
              <p className="title"> {answerNo} </p>
              <FaTimes
                width="30"
                height="30"
                color="#828282"
                innerClassName="icon"
              />
            </button>
          </div>
          <p className="form-subtitle"> {subtitle} </p>

          <input
            type="hidden"
            name="trade_in_valuation[contact_qualification_answer]"
            value={contactQualification}
          />

          <input type="hidden" name="_method" value="patch" />
          <input type="hidden" name={configParam} value={configKey} />
          <input type="hidden" name="creation_token" value={creationToken} />
        </form>
      </div>
    )
  }
}

ContactQualification.propTypes = {
  thankYouTextWhenContactQualificationYes: PropTypes.string,
  thankYouTextWhenContactQualificationNo: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  answerYesPhone: PropTypes.string,
  answerYesEmail: PropTypes.string,
  answerNo: PropTypes.string,
  formUrl: PropTypes.string,
  configKey: PropTypes.string,
  configParam: PropTypes.string,
  creationToken: PropTypes.string,
}
